import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';

import { setLoading } from '../../store/slices/feedback';


const useStyles = makeStyles({
    backdrop: {
        zIndex: 10000,
        color: '#fff'
    }
});
export default () => {
    const classes = useStyles();
    const dispatch = useDispatch()
    const loading = useSelector(state => state.feedback.loading);
    
    return (
        <Backdrop className={classes.backdrop} open={loading}
                onClick={()=>{dispatch(setLoading(false))}}>
            <CircularProgress />
        </Backdrop>
    )
}